import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.83337 9.33329C4.10952 9.33329 4.33337 9.55715 4.33337 9.83329V11.5C4.33337 11.9602 4.70646 12.3333 5.16671 12.3333H6.83337C7.10952 12.3333 7.33337 12.5572 7.33337 12.8333C7.33337 13.1094 7.10952 13.3333 6.83337 13.3333H5.16671C4.15419 13.3333 3.33337 12.5125 3.33337 11.5V9.83329C3.33337 9.55715 3.55723 9.33329 3.83337 9.33329Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 9.33329C13.7762 9.33329 14 9.55715 14 9.83329V11.5C14 12.5125 13.1792 13.3333 12.1667 13.3333H10.5C10.2239 13.3333 10 13.1094 10 12.8333C10 12.5572 10.2239 12.3333 10.5 12.3333H12.1667C12.627 12.3333 13 11.9602 13 11.5V9.83329C13 9.55715 13.2239 9.33329 13.5 9.33329Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.16663C10 2.89048 10.2239 2.66663 10.5 2.66663H12.1667C13.1793 2.66663 14 3.48744 14 4.49996V6.16663C14 6.44277 13.7762 6.66663 13.5 6.66663C13.2239 6.66663 13 6.44277 13 6.16663V4.49996C13 4.03972 12.627 3.66663 12.1667 3.66663H10.5C10.2239 3.66663 10 3.44277 10 3.16663Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.16671 3.66663C4.70647 3.66663 4.33337 4.03972 4.33337 4.49996V6.16663C4.33337 6.44277 4.10952 6.66663 3.83337 6.66663C3.55723 6.66663 3.33337 6.44277 3.33337 6.16663V4.49996C3.33337 3.48744 4.15418 2.66663 5.16671 2.66663H6.83337C7.10952 2.66663 7.33337 2.89048 7.33337 3.16663C7.33337 3.44277 7.10952 3.66663 6.83337 3.66663H5.16671Z"
      fill="currentColor"
    />
  </SvgIcon>
));
